import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSharinginline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M12.5 12H14m-1.5 0h2"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M16.25 10.25c.967 0 1.75.784 1.75 1.75v0a1.75 1.75 0 0 1-1.75 1.75v0A1.75 1.75 0 0 1 14.5 12v0c0-.966.784-1.75 1.75-1.75M9.3 13.5c.966 0 1.75.784 1.75 1.75v0A1.75 1.75 0 0 1 9.3 17v0a1.75 1.75 0 0 1-1.75-1.75v0c0-.966.783-1.75 1.75-1.75m0-6.5c.966 0 1.75.784 1.75 1.75v0A1.75 1.75 0 0 1 9.3 10.5v0a1.75 1.75 0 0 1-1.75-1.75v0C7.55 7.784 8.333 7 9.3 7",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M9.3 13.5v-3"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 10,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgSharinginline;
